import React, { useState } from 'react';
const tableConfig = (props) => (
	{
	
    columns: [
       
		{ title: 'Grand Total Sales', field: 'grandSalesAmount', filterAndSearch: false,
		  render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.grandSalesAmount}</span> : <span>&#36;{rowData.grandSalesAmount}</span>}</div>
		},
		 
 		{ title: 'COD', field: 'codAmount', filterAndSearch: false ,
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.codAmount}</span> : <span>&#36;{rowData.codAmount}</span>}</div>
	    },
		{ title: 'Online', field: 'onlineAmount', filterAndSearch: false ,
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.onlineAmount}</span> : <span>&#36;{rowData.onlineAmount}</span>}</div>
	    },
		{ title: 'Tax', field: 'taxAmount', filterAndSearch: false ,
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.taxAmount}</span> : <span>&#36;{rowData.taxAmount}</span>}</div>
	    },
		{ title: 'Delivery Charges', field: 'deliveryCharges', filterAndSearch: false ,
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.deliveryCharges}</span> : <span>&#36;{rowData.deliveryCharges}</span>}</div>
	    },
		{ title: 'Convenience Fee', field: 'convenienceFees', filterAndSearch: false,
		render:rowData=><div>{( rowData.currency === "&#8377;") ? <span>&#8377;{rowData.convenienceFees}</span> : <span>&#36;{rowData.convenienceFees}</span>}</div>
    	}
		 
       
	 
    ],
})

export const data = [
	{"grandSalesAmount":"0",
	"codAmount":"0",
	"onlineAmount":"0",
	"taxAmount":"0",
	"deliveryCharges":"0",
	"convenienceFees":"0"}
];

export default tableConfig;